export const SAVE_MEMO = 'VARUNA.SAVE_MEMO'
export const GET_MEMO = 'VARUNA.GET_MEMO'
